// imageConstants.js
//at1
import P1_1 from '../../../../../image/programe/program2025/at1/1-1-25.jpg';
import P1_2 from '../../../../../image/programe/program2025/at1/1-2-25.jpg';



//at3

import P4_1 from '../../../../../image/programe/program2025/at4/4-1-25.jpg';


//at4

const at1 = [P1_1];
const at2 = [P1_2];
const at3 = [P1_1];
const at4 = [P4_1];
const at5 = [P1_2];



export const PROGRAM_2025_IMAGES = [at1,at2,at3,at4,at5];